import { Globe2 } from "lucide-react";
import {
  SUPPORTED_LOCALES,
  type LocaleCode,
} from "@/pages/cogo-marketing/i18n/locales";
import { useStudioLocale } from "./use-studio-locale";
import { cn } from "@/lib/utils";

export function StudioLanguageSwitcher({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  const { locale, setLocale, strings } = useStudioLocale();

  return (
    <label
      className={cn(
        "relative inline-flex h-11 items-center rounded-lg text-muted-foreground transition-colors hover:bg-muted/50 hover:text-foreground focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
        compact ? "w-11 justify-center" : "gap-2 px-2.5",
        className,
      )}
      title={strings.language.label}
    >
      <span className="sr-only">{strings.language.label}</span>
      <Globe2 className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden />
      {!compact ? (
        <span className="text-xs font-medium">
          {SUPPORTED_LOCALES.find((item) => item.code === locale)?.nativeLabel}
        </span>
      ) : null}
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as LocaleCode)}
        aria-label={strings.language.label}
        data-testid="studio-language-switcher"
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
      >
        {SUPPORTED_LOCALES.map((item) => (
          <option key={item.code} value={item.code}>
            {item.nativeLabel}
          </option>
        ))}
      </select>
    </label>
  );
}
